export const fuelProviders = [
  { key: "TA-Petro", value: "TA-Petro" },
  { key: "Pipeline", value: "Pipeline" },
  { key: "Esso", value: "Esso" },
  { key: "Pilot", value: "Pilot" },
  { key: "ALL-USD", value: "ALL-USD" }
];